<template>
    <div class="event" >
        <v-container mb-16>
            <div v-bind:key="year.year" v-for="year in years">
                <h4 class="year">{{year.year}}</h4>
                <v-row v-bind:key="event.id" v-for="event in year.events" class="justify-center">
                    <!-- <v-col :cols="5" lg="3" md="3" sm="3" :order="getOrder(year.year)"> -->
                    <v-col :cols="5" lg="3" md="3" sm="3">
                        <v-card class="pb-10 with_shadow" v-prlx="{ 
                            speed: -2,
                            limit: { min: -50, max: 30 }, 
                            direction: 'x'
                            }" >
                            <v-card-text class="month text-center">{{event.month}}</v-card-text>
                            <v-card-title class="day justify-center" >{{event.day}}</v-card-title>
                        </v-card>
                    </v-col>
                    <v-col :cols="4">
                        <h4 class="city">{{event.city}}</h4>
                        <h5 class="location">{{event.location}}</h5>
                        <h6 v-if="event.addInfo" class="addInfo">{{event.addInfo}}</h6>
                    </v-col>
                </v-row>      
            </div>  
        </v-container>
    </div>
</template>

<script>
    export default {
        name: 'Event',
        methods: {
            getOrder(year) {
                if ((parseInt(year) % 2) == 0) {
                    return 0;
                }
                else {
                    return 5;
                }
            }
        },
        props: ["years"], 
        data() {
            return {
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Fauna+One&display=swap');
    @import url('https://fonts.googleapis.com/css2?family=Teko:wght@700&display=swap');
    @import url('https://db.onlinewebfonts.com/c/dd4cd94627c61f898bfd2ee76483fa85?family=Gill+Sans+Nova');

    .with_shadow {
        box-shadow: -26px 29px 13px -6px rgba(0,0,0,0.6);
    }
    .day {
        color: #1765B3;
        font-size: 4rem;    
        font-family: 'Gill Sans Nova', serif;  
    }

    .month {
        color: #1765B3;
        font-family: 'Fauna One', serif;  
    }

    .year {
        font-family: 'Teko', sans-serif;
        font-size: 3rem;
        color: darkgrey;
    }

    .city {
        color: #707070;
        font-family: 'Fauna One', serif;  
        font-size: 1.5rem;
        font-weight: 100;
    }

    .location {
        color: #707070;
        font-family: 'Teko', sans-serif;
        font-size: 1.2rem;
        font-weight: bold;
    }
</style>